import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { watchEffect, ref } from 'vue';
import AppNav from '@/components/AppNav.vue'
import AppFooter from '@/components/AppFooter.vue'
import router from '@/router'
import store from './store';
import Auth from '@/utils/auth'
// import { handleCheckStore, handleCheckGunDB} from '@/dev/testing';
// import moment from 'moment';


// const searchInput = ref('')

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const loading = ref(false)




watchEffect(() => {
  const info = Auth.getProfile()?.data
  console.log(window.location)
  if (window.location.hash == '#/login' && store.state.connected) {
    router.push({ name: 'Popular' })
  }
  if (info) {
    const { username, id } = info
    if (Auth.loggedIn() && !store.state.connected) {

      // console.log({ App_vue: info })
      store.commit('setConnected', true)
      store.commit('setActingAs', info)
      store.commit('setAuthLevel', 'Explorer')
      store.dispatch('login', { username: username, id: id })
    }
    if (!store.state.user && Auth.loggedIn()) {
      store.dispatch('login', { username: username, id: id })


    }
    if (Auth.loggedIn() && !store.state.connected) {
      store.dispatch('login', { username: username, id: id })

    }
  }
  if (!Auth.loggedIn() && store.state.connected) {
    store.dispatch('signout')
    Auth.logout()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    class: "layout hide-scrollbar",
    view: "hHh lpR fFf"
  }, {
    default: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createBlock(_component_q_page_container, {
            key: 0,
            class: "wrapper hide-scrollbar"
          }, {
            default: _withCtx(() => [
              _createVNode(AppNav),
              _createVNode(_component_router_view)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_q_page_container, {
            key: 1,
            class: "wrapper hide-scrollbar"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_linear_progress, {
                indeterminate: "",
                color: "white",
                class: "q-mt-sm"
              }),
              _createVNode(_component_q_linear_progress, {
                query: "",
                color: "secondary",
                class: "q-mt-sm"
              }),
              _createVNode(_component_q_linear_progress, {
                indeterminate: "",
                color: "accent",
                class: "q-mt-sm"
              }),
              _createVNode(_component_q_linear_progress, {
                query: "",
                color: "primary",
                class: "q-mt-sm"
              }),
              _createVNode(_component_q_linear_progress, {
                indeterminate: "",
                rounded: "",
                color: "accent",
                class: "q-mt-sm"
              }),
              _createVNode(_component_q_linear_progress, {
                query: "",
                color: "secondary",
                class: "q-mt-sm"
              }),
              _createVNode(_component_q_linear_progress, {
                indeterminate: "",
                color: "white",
                class: "q-mt-sm"
              })
            ]),
            _: 1
          })),
      _createVNode(AppFooter)
    ]),
    _: 1
  }))
}
}

})